import Cookies from 'universal-cookie';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import MD5 from 'crypto-js/md5';
import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
import axios from 'axios';
// eslint-disable-next-line import/no-cycle
import { getEscopoUsuario, getEscopoAmbiente } from '../../api/autenticacao';
import { MODULOS_TAGS } from '../../components/Shared/Enums/ModulosTelasEnum';
import { ProjetosEnum } from '../../components/Shared/Enums/ProjetosEnum';

let dominioURL = 'one7';
if (window && window.location.hostname !== 'localhost') {
  const hostnameParts = window.location.hostname.split('.');
  dominioURL = hostnameParts[hostnameParts.length - 2];
}

const chaveCriptografia = process.env.REACT_APP_CLIENT_SECRET ?? 'one7';
export const encryptAES = valor => AES.encrypt(valor, chaveCriptografia).toString();
export const decryptAES = valor => AES.decrypt(valor, chaveCriptografia).toString(Utf8);

const dataAtual = new Date().toISOString().slice(0, 10);
const getKeyStorageEncrypted = baseChave => {
  const chave = `x-${dominioURL}-${baseChave}`;
  const criptoIV = CryptoJS.enc.Utf8.parse(chaveCriptografia.substring(0, 6) + dataAtual);
  const criptoKey = CryptoJS.enc.Utf8.parse(chaveCriptografia.substring(0, 32));
  const encrypted = CryptoJS.AES.encrypt(chave, criptoKey, {
    iv: criptoIV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
};

// NOMES DE LOCAL STORAGE E SESSION STORAGE
export const TOKEN_KEY = getKeyStorageEncrypted('token');
export const USUARIO_LOGADO = getKeyStorageEncrypted('usuario');
export const TOKEN_EXPIRES = getKeyStorageEncrypted('token-expires');
export const TOKEN_KEY_REFRESH = getKeyStorageEncrypted('token-refresh');
export const TOKEN_REFRESH_EXPIRES = getKeyStorageEncrypted('token-refresh-expires');
export const ESCOPO_COMPONENTES = getKeyStorageEncrypted('escopo-componentes');
export const TELA_DEFAULT = getKeyStorageEncrypted('tela-default');
export const TELA_ABERTA = getKeyStorageEncrypted('tela-aberta');
export const MENU_ABERTO = getKeyStorageEncrypted('menu-aberto');
export const LST_DEPARTAMENTOS = getKeyStorageEncrypted('lst-departamentos');
export const DEPARTAMENTO_SELECIONADO = getKeyStorageEncrypted('departamento-selecionado');
export const BTN_MAIS_CLICADO = getKeyStorageEncrypted('btn-mais-clickado');
export const CLIENTE_SELECIONADO = getKeyStorageEncrypted('cliente');
export const EMAIL_VALIDA_TOKEN = getKeyStorageEncrypted('header-email-validacao-token');
export const HEADER_SIDEBAR_NOVO = getKeyStorageEncrypted('header-sidebar-novo');
export const CONFIG_AMBIENTE = getKeyStorageEncrypted('configuracoes-ambiente');
export const ETAPA_CAPITAL_FLOW = getKeyStorageEncrypted('capital-flow');

// NOMES DE COOKIES
export const AUTH_COOKIE = 'x-one7-auth-cookie';
export const AUTH_COOKIE_TOKEN = 'x-one7-auth-cookie-token';
export const AUTH_COOKIE_TOKEN_REFRESH = 'x-one7-auth-cookie-token-refresh';
export const CLIENTE_SELECIONADO_COOKIE = 'x-one7-cliente';
export const DESABILITAR_MENU = 'x-one7-desabilitar-menu';
export const PLATAFORMA_CLIENTE_INFOS = 'x-one7-cliente-infos';

export const isAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const getTokenRefresh = () => localStorage.getItem(TOKEN_KEY_REFRESH);

export const setToken = (token, expires) => {
  const expireTimestamp = moment().add(expires, 'seconds').valueOf();
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(TOKEN_EXPIRES, expireTimestamp);
};

export const setTokenRefresh = (token, expires) => {
  const expireTimestamp = moment().add(expires, 'seconds').valueOf();
  localStorage.setItem(TOKEN_KEY_REFRESH, token);
  localStorage.setItem(TOKEN_REFRESH_EXPIRES, expireTimestamp);
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_EXPIRES);
};

export const tokenIsExpired = () => {
  const tokenTimestamp = +localStorage.getItem(TOKEN_EXPIRES);
  const currentTimestamp = +moment().valueOf();
  return currentTimestamp > tokenTimestamp;
};

export const removeTokenRefresh = () => {
  localStorage.removeItem(TOKEN_KEY_REFRESH);
  localStorage.removeItem(TOKEN_REFRESH_EXPIRES);
};

export const tokenRefreshIsExpired = () => {
  const tokenTimestamp = +localStorage.getItem(TOKEN_REFRESH_EXPIRES);
  const currentTimestamp = +moment().valueOf();
  return currentTimestamp > tokenTimestamp;
};

export const setDadosUsuario = dadosUsuario => {
  const dadosEncrypted = encryptAES(JSON.stringify(dadosUsuario));
  localStorage.setItem(USUARIO_LOGADO, dadosEncrypted);
};

export const getDadosUsuario = () => {
  const dados = localStorage.getItem(USUARIO_LOGADO);
  if (dados) {
    const decryptedBytes = decryptAES(dados);
    return JSON.parse(decryptedBytes);
  }
  return null;
};

export const getCodUsuarioLogado = () => {
  const dadosUsuario = getDadosUsuario();

  if (dadosUsuario?.cod_usuario) {
    return dadosUsuario.cod_usuario;
  }

  const jwtToken = parseJwt(getToken() || '');

  return jwtToken?.id || jwtToken?.cod_usuario || jwtToken?.codUsuario || null;
};

export const setEscopoComponentes = escopo => {
  const dadosEncrypted = encryptAES(JSON.stringify(escopo));
  sessionStorage.setItem(ESCOPO_COMPONENTES, dadosEncrypted);
};

export const getEscopoComponentes = () => {
  const escopoAcesso = sessionStorage.getItem(ESCOPO_COMPONENTES);
  if (escopoAcesso) {
    try {
      const decryptedBytes = decryptAES(escopoAcesso);
      return JSON.parse(decryptedBytes);
    } catch (er) {
      console.error('getEscopoComponentes', er);
      return false;
    }
  }
  return false;
};

export const setTelaDefault = telaDefault => {
  const dadosEncrypted = encryptAES(JSON.stringify(telaDefault));
  sessionStorage.setItem(TELA_DEFAULT, dadosEncrypted);
};

export const getTelaDefault = () => {
  const telaDefault = sessionStorage.getItem(TELA_DEFAULT);
  if (telaDefault) {
    try {
      const decryptedBytes = decryptAES(telaDefault);
      return JSON.parse(decryptedBytes);
    } catch (er) {
      console.error('getEscopoComponentes', er);
      return null;
    }
  }
  return null;
};

export const setTelaAberta = telaAberta => {
  sessionStorage.setItem(TELA_ABERTA, telaAberta);
};

export const deleteTelaAberta = () => {
  sessionStorage.removeItem(TELA_ABERTA);
};

export const setMenuAberto = menuAberto => {
  sessionStorage.setItem(MENU_ABERTO, menuAberto);
};

export const deleteMenuAberto = () => {
  sessionStorage.removeItem(MENU_ABERTO);
};

export const setLstDepartamentosStorage = lstDepartamentos => {
  const dadosEncrypted = encryptAES(JSON.stringify(lstDepartamentos));
  localStorage.setItem(LST_DEPARTAMENTOS, dadosEncrypted);
};

export const getLstDepartamentosStorage = () => {
  const dados = localStorage.getItem(LST_DEPARTAMENTOS);
  if (dados) {
    try {
      const decryptedBytes = decryptAES(dados);
      return JSON.parse(decryptedBytes);
    } catch (er) {
      console.error('getLstDepartamentosStorage', er);
      return null;
    }
  }
  return null;
};

export const setDepartamentoSelecionadoSession = departamento => {
  const dadosEncrypted = encryptAES(JSON.stringify(departamento));
  sessionStorage.setItem(DEPARTAMENTO_SELECIONADO, dadosEncrypted);
};

export const geDepartamentoSession = () => {
  const dados = sessionStorage.getItem(DEPARTAMENTO_SELECIONADO);
  if (dados) {
    try {
      const decryptedBytes = decryptAES(dados);
      return JSON.parse(decryptedBytes);
    } catch (er) {
      console.error('geDepartamentoSession', er);
      return null;
    }
  }
  return null;
};

export const deleteDepartamentoSelecionadoSession = () => {
  sessionStorage.removeItem(DEPARTAMENTO_SELECIONADO);
};

export const getCodDepartamentoSession = () => {
  const dados = geDepartamentoSession();
  return dados && dados.id ? dados.id : null;
};

export const getNomeDepartamentoSession = () => {
  const dados = geDepartamentoSession();
  return dados && dados.label ? dados.label : null;
};

export const setBtnMaisClickadoSession = () => {
  sessionStorage.setItem(BTN_MAIS_CLICADO, true);
};

export const getBtnMaisClickadoSession = () => sessionStorage.getItem(BTN_MAIS_CLICADO);

export const deleteBtnMaisClickadoSession = () => sessionStorage.removeItem(BTN_MAIS_CLICADO);

export const setMenusDepartamento = (departamentoId, menus) => {
  const encrypted = encryptAES(JSON.stringify(menus));
  const keyEncrypted = getKeyStorageEncrypted(`lst-menus-${departamentoId}`);
  localStorage.setItem(keyEncrypted, encrypted);
};

export const getMenusDepartamento = departamentoId => {
  const keyEncrypted = getKeyStorageEncrypted(`lst-menus-${departamentoId}`);
  const dados = localStorage.getItem(keyEncrypted);
  if (dados) {
    try {
      const decryptedBytes = decryptAES(dados);
      return JSON.parse(decryptedBytes);
    } catch (er) {
      console.error('getMenusDepartamento', er);
      return null;
    }
  }
  return null;
};

export const removeDepartamentoStorage = departamentoId => {
  const keyEncrypted = getKeyStorageEncrypted(`lst-menus-${departamentoId}`);
  localStorage.removeItem(keyEncrypted);
};

export const getTelaAbertaSession = () => sessionStorage.getItem(TELA_ABERTA);

export const verificaTelaAberta = telaAberta => {
  const telaSession = sessionStorage.getItem(TELA_ABERTA);
  return telaSession && telaSession === telaAberta;
};

export const verificaMenuAberto = menuAberto => {
  const menuSession = sessionStorage.getItem(MENU_ABERTO);
  return menuSession && parseInt(menuSession) === parseInt(menuAberto);
};

export const setClienteAtual = cliente => {
  if (cliente) {
    const dadosEncrypted = encryptAES(JSON.stringify(cliente));
    sessionStorage.setItem(CLIENTE_SELECIONADO, dadosEncrypted);
  }
};

export const getClienteAtual = () => {
  const dados = sessionStorage.getItem(CLIENTE_SELECIONADO);
  if (dados) {
    try {
      const decryptedBytes = decryptAES(dados);
      return JSON.parse(decryptedBytes);
    } catch (er) {
      console.error('getClienteAtual', er);
      return null;
    }
  }
  return null;
};

export const setConfigAmbiente = escopo => {
  if (escopo && escopo.sistema) {
    escopo.dataEscopo = parseInt(moment().format('YYMMDD'), 10);
    const encryptedBytes = encryptAES(JSON.stringify(escopo));
    localStorage.setItem(CONFIG_AMBIENTE, encryptedBytes);
    return escopo;
  } else return false;
};

export const getConfigAmbiente = () => {
  const configAmbiente = localStorage.getItem(CONFIG_AMBIENTE);
  if (configAmbiente) {
    try {
      const decryptedBytes = decryptAES(configAmbiente);
      if (!decryptedBytes) {
        localStorage.removeItem(CONFIG_AMBIENTE);
        return false;
      }
      return JSON.parse(decryptedBytes);
    } catch (er) {
      localStorage.removeItem(CONFIG_AMBIENTE);
      return false;
    }
  }
  return false;
};

export const getConfigAmbienteDominio = () => {
  const configAmbiente = getConfigAmbiente();
  let dominio =
    configAmbiente && configAmbiente.sistema && configAmbiente.sistema.dominio
      ? configAmbiente.sistema.dominio
      : '';
  if (dominio === '') {
    const hostnameParts = window.location.hostname.split('.');
    dominio = hostnameParts[hostnameParts.length - 2];
  }
  return dominio;
};

export const setTempSession = (key, value) => {
  const keyEncrypted = getKeyStorageEncrypted(key);
  const decryptedBytes = encryptAES(JSON.stringify(value));
  sessionStorage.setItem(keyEncrypted, decryptedBytes);
};

export const getTempSession = key => {
  const keyEncrypted = getKeyStorageEncrypted(key);
  const item = sessionStorage.getItem(keyEncrypted);
  if (item) {
    try {
      const decryptedBytes = decryptAES(item);
      return JSON.parse(decryptedBytes);
    } catch (er) {
      console.error(`getTempSession ${key}`, er);
      return false;
    }
  }
  return false;
};

export const removeTempSession = key => {
  const keyEncrypted = getKeyStorageEncrypted(key);
  sessionStorage.removeItem(keyEncrypted);
};

export const buscarTelaAtual = (sufix = '') => {
  const menuAtual = sessionStorage.getItem(getKeyStorageEncrypted(`menu-atual${sufix}`));
  const rotaAtual = sessionStorage.getItem(getKeyStorageEncrypted(`rota-atual${sufix}`));
  const projetoAtual = sessionStorage.getItem(getKeyStorageEncrypted(`projeto-atual${sufix}`));
  return { menuAtual, projetoAtual, rotaAtual };
};

export const gravarTelaAtual = ({ menu, rota, projeto, sufix = '' }) => {
  if (menu) sessionStorage.setItem(getKeyStorageEncrypted(`menu-atual${sufix}`), menu);
  if (rota) sessionStorage.setItem(getKeyStorageEncrypted(`rota-atual${sufix}`), rota);
  if (projeto) sessionStorage.setItem(getKeyStorageEncrypted(`projeto-atual${sufix}`), projeto);
  return true;
};

export const removerTelaAtual = (sufix = '') => {
  sessionStorage.removeItem(getKeyStorageEncrypted(`menu-atual${sufix}`));
  sessionStorage.removeItem(getKeyStorageEncrypted(`rota-atual${sufix}`));
  sessionStorage.removeItem(getKeyStorageEncrypted(`projeto-atual${sufix}`));
  return true;
};

export const autenthicaToken = (token, tokenRefresh, setEscopoAcesso) =>
  new Promise(resolve => {
    if (token && tokenRefresh) {
      const jwtToken = parseJwt(token);
      const jwtTokenRefresh = parseJwt(tokenRefresh);
      if (jwtToken && jwtToken.id && jwtToken.nome && jwtToken.exp && jwtTokenRefresh) {
        const dadosCookie = getDataFromCookie();
        const dadosCliente = getClienteFromCookie();
        setClienteAtual(dadosCliente);
        const fpPromise = getCompleteBrowserInfo();
        // eslint-disable-next-line no-promise-executor-return
        return fpPromise
          .then(resultado => {
            const dadosFingerprint = resultado ?? null;
            const md5Gerado = geraMD5Token(jwtToken.id, dadosFingerprint);

            if (dadosCookie && md5Gerado === dadosCookie) {
              const dadosUsuario = {
                cod_usuario: jwtToken.id,
                nome_usuario: jwtToken.nome
              };

              setToken(token, jwtToken.exp);
              setTokenRefresh(tokenRefresh, jwtTokenRefresh.exp);
              setDadosUsuario(dadosUsuario);

              // carregarEscopoUsuario SUBSTITUI o escopo, nao mescla: um modulo
              // fora desta lista simplesmente nao existe para quem entra por
              // cookie. plataforma_oneshell e capital_flow estavam de fora, e e
              // de onde vem o gate do chat de IA (componente chat-ia) e os
              // componentes de saldo da Home.
              const modulos = [
                MODULOS_TAGS.PLATAFORMACLIENTE,
                MODULOS_TAGS.PLATAFORMA_CRM,
                MODULOS_TAGS.PLATAFORMA_FORMALIZACAO,
                MODULOS_TAGS.PLATAFORMA_RELACIONAMENTOS,
                MODULOS_TAGS.PLATAFORMA_ONESHELL,
                MODULOS_TAGS.PLATAFORMA_CAPITAL_FLOW
              ];

              return carregarEscopoUsuario(modulos, setEscopoAcesso).then(() => resolve(true));
            } else {
              // eslint-disable-next-line no-console
              console.error(
                'cookies (dadosCookie && md5Gerado === dadosCookie)',
                dadosCookie,
                md5Gerado
              );
              return resolve(true);
            }
          })
          .catch(err => {
            // eslint-disable-next-line no-console
            console.error(err);
            return resolve(true);
          });
      } else {
        console.error('jwToken', jwtToken);
        return resolve(true);
      }
    } else {
      console.error('token', token);
      return resolve(true);
    }
  });

export const limparSessao = () => {
  sessionStorage.clear();
  const configAmbiente = localStorage.getItem(CONFIG_AMBIENTE);
  const headerSidebarNovo = localStorage.getItem(HEADER_SIDEBAR_NOVO);
  localStorage.clear();
  localStorage.setItem(CONFIG_AMBIENTE, configAmbiente);
  localStorage.setItem(HEADER_SIDEBAR_NOVO, headerSidebarNovo);
};

export const parseJwt = token => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

export const getDataFromCookie = () => {
  const cookies = new Cookies();
  return cookies.get(AUTH_COOKIE);
};

export const getClienteFromCookie = () => {
  const cookies = new Cookies();
  return cookies.get(CLIENTE_SELECIONADO_COOKIE);
};

export const geraMD5Token = (codUsuario, fingerPrint) => MD5(codUsuario + fingerPrint).toString();

const formatarEscopo = resEscopo => {
  let lstEscopo = resEscopo.perfil ? resEscopo.perfil : [];
  lstEscopo = lstEscopo.concat(resEscopo.complementos ? resEscopo.complementos : []);
  const escopo = {};
  lstEscopo.map(itemEscopo => {
    if (itemEscopo.tipo_chave && itemEscopo.chave) {
      const tipoChave = itemEscopo.tipo_chave.toLowerCase();
      const chave = itemEscopo.chave.toLowerCase();
      if (escopo[tipoChave] === undefined) {
        escopo[tipoChave] = {};
      }
      escopo[tipoChave][chave] = itemEscopo;
    }
    return itemEscopo;
  });
  return escopo;
};

const getCompleteBrowserInfo = () => {
  const browserInfo = getBrowserInfo();
  const timeZoneInfo = getTimeZoneInfo();

  const completeInfo = {
    browserInfo,
    timeZoneInfo
  };

  const orderedCompleteInfo = Object.keys(completeInfo)
    .sort()
    .reduce((obj, key) => {
      obj[key] = completeInfo[key];
      return obj;
    }, {});

  // Converter o objeto ordenado para uma string
  const jsonString = JSON.stringify(orderedCompleteInfo);
  return jsonString;
};

const getBrowserInfo = () => {
  const browserInfo = {
    userAgent: navigator.userAgent, // Informações completas do navegador
    language: navigator.language, // Línguagem do navegador
    platform: navigator.platform, // Sistema operacional (Windows, Mac, etc.)
    cookieEnabled: navigator.cookieEnabled, // Se os cookies estão habilitados
    online: navigator.onLine // Se o navegador está online
  };
  return browserInfo;
};

const getTimeZoneInfo = () => {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const { locale } = Intl.DateTimeFormat().resolvedOptions();
  return { timeZone, locale };
};

export const carregarEscopoAmbienteTenant = funcaoRetorno => {
  const configAmbiente = getConfigAmbiente();
  const dataHoje = parseInt(moment().format('YYMMDD'), 10);
  if (configAmbiente && configAmbiente.dataEscopo && configAmbiente.dataEscopo === dataHoje) {
    funcaoRetorno(configAmbiente);
    return true;
  }
  return getEscopoAmbiente()
    .then(resEscopo => {
      // SETA AS CONFIGURACOES DE AMBIENTE
      const dadosEscopo = resEscopo.data || null;
      if (dadosEscopo && dadosEscopo.sistema && dadosEscopo.sistema.dominio) {
        const escopoSalvo = setConfigAmbiente(dadosEscopo);
        if (escopoSalvo) {
          funcaoRetorno(escopoSalvo);
        } else {
          funcaoRetorno({});
        }
      } else {
        // eslint-disable-next-line no-console
        console.error('carregarEscopoAmbienteTenant retorno nulo', dadosEscopo);
        setConfigAmbiente({});
        funcaoRetorno({});
      }
    })
    .catch(err => {
      // eslint-disable-next-line no-console
      console.error('carregarEscopoAmbienteTenant', err);
      setConfigAmbiente({});
      funcaoRetorno({});
      throw err;
    });
};

export const criaCookieToken = (token = null) => {
  const configAmbiente = getConfigAmbiente();
  const dominio =
    configAmbiente && configAmbiente.sistema && configAmbiente.sistema.dominio
      ? configAmbiente.sistema.dominio
      : 'one7.in';
  const expirationInSeconds = 120;
  const expirationDate = new Date(Date.now() + expirationInSeconds * 1000);

  deleteCookie(AUTH_COOKIE, dominio);

  if (!token || token === null) {
    token = getToken();
  }

  if (!token) {
    return false;
  }

  try {
    const dadosFingerprint = getCompleteBrowserInfo() ?? null;
    const jwtToken = parseJwt(token);
    const tokenRefresh = getTokenRefresh();

    if (!jwtToken?.id) {
      return false;
    }

    const md5Gerado = geraMD5Token(jwtToken.id, dadosFingerprint);
    const { userAgent, language } = navigator;
    const locale = language.replace('-', '_');
    const md5React = geraMD5Token(jwtToken.id, userAgent + locale);

    criaCookie(AUTH_COOKIE, md5Gerado, dominio, expirationDate);
    criaCookie(AUTH_COOKIE_TOKEN, token, dominio, expirationDate);
    criaCookie(AUTH_COOKIE_TOKEN_REFRESH, tokenRefresh, dominio, expirationDate);
    criaCookie(DESABILITAR_MENU, true, dominio, expirationDate);
    criaCookie(PLATAFORMA_CLIENTE_INFOS, md5React, dominio, expirationDate);

    return true;
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('criaCookieToken', err);
    return false;
  }
};

export const criaCookie = (chave, valor, dominio, expirationDate) => {
  const cookies = new Cookies();
  cookies.set(chave, valor, {
    path: '/',
    expires: expirationDate,
    domain: dominio,
    secure: window.location.protocol === 'https:'
  });
};

export const deleteCookie = (chave, dominio) => {
  const cookies = new Cookies();
  cookies.set(chave, '', {
    path: '/',
    expires: new Date(0),
    domain: dominio,
    secure: window.location.protocol === 'https:'
  });
};

export const refreshAccessToken = async () => {
  // Sem refresh_token nao ha o que renovar. Prosseguir aqui faria um POST
  // /login vazio, que falha e cai no catch abaixo redirecionando para
  // /force-logout -- inclusive durante a propria tela de login.
  if (!getTokenRefresh()) {
    return null;
  }

  const form = new URLSearchParams();
  form.append('client_id', process.env.REACT_APP_CLIENT_ID);
  form.append('client_secret', process.env.REACT_APP_CLIENT_SECRET);
  form.append('grant_type', process.env.REACT_APP_GRANT_TYPE_REFRESH_TOKEN);
  form.append('refresh_token', getTokenRefresh());

  try {
    const api = axios.create({ baseURL: process.env.REACT_APP_LOGIN });

    api.interceptors.request.use(config => {
      const token = getToken();
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    });

    const ret = await api.post('/login', form);
    const { access_token, expires_in, refresh_token, refresh_expires_in } = ret.data;

    setToken(access_token, expires_in);
    setTokenRefresh(refresh_token, refresh_expires_in);
    return access_token;
  } catch (err) {
    window.location.replace('/force-logout');
    return null;
  }
};

export const carregarEscopoUsuario = async (modulos, setEscopoAcesso) => {
  try {
    const resEscopo = await getEscopoUsuario({ modulos });

    if (!(resEscopo.data && Object.keys(resEscopo.data).length > 1)) {
      console.error('escopo nulo');
      return false;
    }

    const escopo = resEscopo.data;
    const escoposModulos = {};

    Object.keys(escopo).forEach(modulo => {
      if (modulo !== 'telaDefault') {
        escoposModulos[modulo] = formatarEscopo({
          ...escopo[modulo]
        });
      }
    });

    setEscopoAcesso(escoposModulos);
    setEscopoComponentes(escoposModulos);

    if (escopo.telaDefault) {
      setTelaDefault(escopo.telaDefault);
    }

    if (getConfigAmbiente()) {
      const resAmbiente = await getEscopoAmbiente();
      const dadosAmbiente = resAmbiente.data || null;
      if (dadosAmbiente) {
        setConfigAmbiente(dadosAmbiente);
      }
    }

    return true;
  } catch (err) {
    console.error('Erro ao carregar escopo do usuário:', err);
    return false;
  }
};

export const montaUrlExterna = (rota, projeto, params = '') => {
  let url = '';

  if (projeto === ProjetosEnum.ISEVEN) {
    const rotaLimpa = rota ? String(rota).trim() : '';
    const paramsLimp = params ? String(params).trim() : '';
    const rotaComParams = rotaLimpa + paramsLimp;

    url = rotaComParams
      ? `${process.env.REACT_APP_ISEVEN_BASE_URL}/AuthKeyCloack.php?url=${rotaComParams}`
      : `${process.env.REACT_APP_ISEVEN_BASE_URL}/AuthKeyCloack.php`;
  } else if (projeto === ProjetosEnum.MODULUS) {
    const rotaModulus = process.env.REACT_APP_MODULUS_BASE_URL;
    const rotaKeyCloak = process.env.REACT_APP_MODULUS_KEYCLOACK_LOGIN;

    // params vem como '?submenu=X&CODTITULO=Z&CODOPERACAO=Y'
    // converte '?' em '&' para concatenar na querystring do Modulus
    const queryExtra = params ? params.replace(/^\?/, '&') : '';

    url = `${rotaModulus}${rotaKeyCloak}?to=${rota}${queryExtra}&desabilitar_menu=S`;
  } else if (projeto === ProjetosEnum.PLATAFORMA_CLIENTE) {
    const token = getToken();
    const tokenRefresh = getTokenRefresh();
    rota = rota.replaceAll('/', '|');
    url = `${process.env.REACT_APP_LINK_PLATAFORMA_DIGITAL}${process.env.REACT_APP_PLATAFORMA_DIGITAL_ENDDOMAIN ?? ''}/#/authentication/logar/${rota}/${token}/${tokenRefresh}`;
  } else if (projeto === ProjetosEnum.HUB_UI) {
    const token = getToken();
    const tokenRefresh = getTokenRefresh();
    rota = rota.replaceAll('/', '|');
    url = `${process.env.REACT_APP_LINK_HUB_UI}/auth/${rota}/${token}/${tokenRefresh}`;
  } else {
    url = `${rota}`;
  }

  const dominioUrl = getConfigAmbienteDominio();
  return url.replace('TENANT', dominioUrl);
};

export const getEmailValidaToken = () => {
  if (sessionStorage.getItem(EMAIL_VALIDA_TOKEN)) {
    return sessionStorage.getItem(EMAIL_VALIDA_TOKEN);
  } else {
    return false;
  }
};

export const setEmailValidaToken = emailValidaToken => {
  sessionStorage.setItem(EMAIL_VALIDA_TOKEN, emailValidaToken);
};

export const getHeaderSidBarNovo = () => localStorage.getItem(HEADER_SIDEBAR_NOVO);

export const setHeaderSidBarNovo = tipo => {
  if (tipo) {
    localStorage.setItem(HEADER_SIDEBAR_NOVO, tipo);
  } else {
    localStorage.removeItem(HEADER_SIDEBAR_NOVO);
  }
};

export const showNotification = (title, options) => {
  if (!('Notification' in window)) {
    return;
  }

  const createNotification = () => {
    const notification = new Notification(title, options);
    notification.onclick = () => {
      window.focus();
    };
  };

  if (Notification.permission === 'granted') {
    createNotification();
  } else if (Notification.permission === 'default') {
    Notification.requestPermission().then(permission => {
      if (permission === 'granted') {
        createNotification();
      }
    });
  }
};

export const slugify = str =>
  str
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]/g, '');

export const aplicaCoresOneShell = (coresArray = [], mode = true) => {
  if (!coresArray || coresArray.length <= 0) {
    const config = getConfigAmbiente();
    coresArray = config?.cores?.ONESHELL ?? [];
  }

  if (coresArray.length <= 0) {
    return;
  }

  coresArray.forEach(({ TIPO, NOME, LIGHT, DARK }) => {
    const nomeVar = `--${slugify(TIPO)}-${slugify(NOME)}`;
    document.documentElement.style.setProperty(nomeVar, mode ? LIGHT : DARK);
  });
};

export const getEtapaSessionCapitalFlow = () => sessionStorage.getItem(ETAPA_CAPITAL_FLOW);

export const setEtapaSessionCapitalFlow = etapa => {
  sessionStorage.setItem(ETAPA_CAPITAL_FLOW, etapa);
};
